import { useState } from 'react'
export const useHistoryDiagnosisModal = () => {
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false)

  const openHistoryModal = () => {
    setIsHistoryModalOpen(true)
  }

  const closeHistoryModal = () => {
    setIsHistoryModalOpen(false)
  }

  return {
    isHistoryModalOpen,
    openHistoryModal,
    closeHistoryModal
  }
}
